module.exports = __webpack_public_path__ + "images/Up.d91f146e98eee35401d6dbc29da29441.svg";